import { render, staticRenderFns } from "./change-method.vue?vue&type=template&id=523368b8&scoped=true&"
import script from "./change-method.vue?vue&type=script&lang=js&"
export * from "./change-method.vue?vue&type=script&lang=js&"
import style0 from "./change-method.vue?vue&type=style&index=0&id=523368b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "523368b8",
  null
  
)

export default component.exports